import { useSelector, useDispatch } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import isEmpty from 'lodash/isEmpty'
import { useTrackingContext } from '../../../../../providers/tracking'
import { Button, Text, If, Unless } from '../../../..'
import { WizardButtonGroup } from '../Button'
import Goal from '../../Goal'
import {
  NEW_ORDERED_HOMEOWNER_GOALS,
  NEW_ORDERED_NON_HOMEOWNER_GOALS,
  NEW_GOAL_MESSAGE_MAP,
  NEW_STEPS,
  QUESTION_GOALS,
  GOALS
} from '../../../../../constants/client/onboarding'
import * as Icons from './Goals'
import { useWizardProvider } from '../../../../shared/WizardContext'
import { saveClientAnswer } from '../../../../../actions/client'
import { setBuyerOnboardingGoal } from '../../../../../actions/buyerOnboarding'
import { selectIsHomeowner } from '../../../../../store/selectors/client'
import { selectBuyerOnboardingGoal } from '../../../../../store/selectors/buyerOnboarding'

import baseStyles from '../../BuyerOnboardingWizard.module.scss'
import styles from './EnterGoal.module.scss'

const GOAL_ICON_MAP = {
  [GOALS.GOAL_EXPLORE]: Icons.Explore,
  [GOALS.GOAL_FIRST_HOME]: Icons.FirstHome,
  [GOALS.GOAL_INVEST]: Icons.Invest,
  [GOALS.GOAL_NEW_HOME]: Icons.NewHome
}

const EnterGoal = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const { trackingClient } = useTrackingContext()
  const { goBack, goTo, goForward } = useWizardProvider()

  const selectedGoal = useSelector(selectBuyerOnboardingGoal) || ''
  const isHomeowner = useSelector(selectIsHomeowner)

  const saveGoal = goal => {
    trackingClient?.buyerOnboarded({ priority_set: goal })
    dispatch(setBuyerOnboardingGoal(goal))
    dispatch(
      saveClientAnswer({
        question: QUESTION_GOALS,
        response: {
          value: goal
        }
      })
    )

    switch (goal) {
      case GOALS.GOAL_FIRST_HOME:
        goTo(NEW_STEPS.BUYER_PRIORITY)
        break
      default:
        goForward()
    }
  }

  const orderedGoals = isHomeowner ? NEW_ORDERED_HOMEOWNER_GOALS : NEW_ORDERED_NON_HOMEOWNER_GOALS

  return (
    <div className={baseStyles.step} data-qa='enter-goals'>
      <div>
        <Text.Headline>
          <FormattedMessage id='BuyerOnboarding.goalStep.headline' defaultMessage='What are you looking to do?' />
        </Text.Headline>
      </div>
      <div className={baseStyles.goalsContainer}>
        {orderedGoals.map(goal => {
          const GoalIcon = GOAL_ICON_MAP[goal]
          const copy = NEW_GOAL_MESSAGE_MAP[goal] || null
          const formattedCopy = intl.formatMessage(copy)

          return (
            <Goal
              className={styles.goal}
              goal={goal}
              copy={formattedCopy}
              icon={GoalIcon}
              key={goal}
              onClick={saveGoal}
              selectedGoal={selectedGoal}
            />
          )
        })}
      </div>
      <WizardButtonGroup className={styles.buttonGroup}>
        <Button.Back onClick={goBack} />
        <If condition={isEmpty(selectedGoal)}>
          <Button.Forward onClick={() => goTo(NEW_STEPS.BUYER_THINKING_OF_SELLING_HOME)}>
            <FormattedMessage id='NewBuyerOnboarding.buttonGroup.skip' defaultMessage='Skip for now' />
          </Button.Forward>
        </If>
        <Unless condition={isEmpty(selectedGoal)}>
          <Button.Forward onClick={() => saveGoal(selectedGoal)}>
            <FormattedMessage id='NewBuyerOnboarding.buttonGroup.continue' defaultMessage='Continue' />
          </Button.Forward>
        </Unless>
      </WizardButtonGroup>
    </div>
  )
}

export default EnterGoal
